import { render } from "./HomeParceiros.vue?vue&type=template&id=31c48395&scoped=true"
import script from "./HomeParceiros.vue?vue&type=script&lang=js"
export * from "./HomeParceiros.vue?vue&type=script&lang=js"

import "./HomeParceiros.vue?vue&type=style&index=0&id=31c48395&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31c48395"]])

export default __exports__